<script setup lang="ts">
import { useAppState } from '@src/store/ocg-app-state';
import { computed } from 'vue';

// Define component props
const props = defineProps({ forceLight: { type: Boolean, default: false } });

const appState = useAppState();
const logoURL = computed(() => {
  return appState.getCurrentLogo(props.forceLight);
});
</script>

<template>
  <img :src="logoURL" alt="Logo" class="logo" style="opacity: 0.2">
</template>
